var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-content',{attrs:{"app":""}},[_c('v-container',{attrs:{"fluid":""}},[_c('v-card',{staticClass:"v-card---style"},[_c('section',[_c('h2',{staticClass:"mb-4"},[_vm._v("\n          User Management\n        ")])])])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22927df4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/UserManagement.vue
// module id = null
// module chunks = 